import { all } from "redux-saga/effects";
import ModulesSaga from "./modules/sagas";
import CreationSaga from "./creation/sagas";

export default function* rootSaga() {
  yield all([ModulesSaga(), CreationSaga()]);
}
